import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import { Context } from "../contexts/AppContext";
import { FaLock } from "react-icons/fa";
import { getData, postData } from "../../lib/utils";

function PasswordModal(props) {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  const [modalOpen, setModalOpen] = useState(appState.modalData);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const [galleryData, setGalleryData] = useState(appState?.gallery);

  useEffect(() => {
    setModalOpen(appState.modalData);
  }, [appState.modalData]);

  // useEffect(() => {

  //   console.log("RESSSSSSSSSS ponse ",appState.modalData.galleryId)
  //   const fetchGallery = async () => {
  //     if (appState?.modalData?.galleryId) {
  //       const res = await getData(
  //         `galleries/gallery/${appState.modalData.galleryId}`
  //       );
       
  //       if (res) {
  //         setGalleryData(res.gallery);
  //       }
  //     }
  //   };

  //   fetchGallery();
  // }, [appState.modalData]);

  Modal.setAppElement("#root");

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "400px",
      width: "90%",
      backgroundColor: "#1f2937",
      borderRadius: "12px",
      padding: "25px",
      textAlign: "center",
      color: "white",
    },
    overlay: {
      backgroundColor: "rgba(0,0,0,0.6)",
    },
  };

  const closeModal = () => {
    setAppState((prevState) => ({
      ...prevState,
      modalData: { ...prevState.modalData, type: null, isOpen: false },
    }));
  };

  const handleSubmit = async () => {
    setError("");

    // 🔐 Backend verify API call (recommended)
    
    try {

      console.log("aaaaa ",galleryData)
     

  const res = await postData(
  "galleries/verify-password",
  {
    galleryId: galleryData._id,
    password: password,
  }
);

      if (res?.success) {
        closeModal();

        // ✅ Allow access (example)
        setAppState((prev) => ({
          ...prev,
          isUnlocked: true,
        }));
        props.passwordMatched();
      } else {
        setError("Wrong password ❌");
      }
    } catch (err) {
      setError("Something went wrong");
    }
  };

  return (
    <Modal
      isOpen={modalOpen.isOpen && modalOpen.type === "PasswordModal"}
      
      style={customStyles}
    >
      <div className="flex flex-col items-center gap-4">

        <FaLock size={30} />

        <h2 className="text-lg font-semibold">Protected Gallery</h2>

        <p className="text-sm text-gray-300">
          Enter password to access this gallery
        </p>

        <input
          type="password"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-3 py-2 rounded bg-gray-700 text-white outline-none"
        />

        {error && <p className="text-red-400 text-sm">{error}</p>}

        <button
          onClick={handleSubmit}
          className="bg-gray-600 hover:bg-gray-500 px-4 py-2 rounded w-full"
        >
          Unlock
        </button>
 
      </div>
    </Modal>
  );
}

export default PasswordModal;